import {jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class LoraPacketTxInfo {

  @jsonMember({name: 'frequency'})
  public Frequency!: number;

  @jsonMember({name: 'modulation'})
  public Modulation!: string;

  @jsonMember({name: 'datarate'})
  public Datarate!: number;

  @jsonMember({name: 'spreadFactor'})
  public SpreadFactor!: number;

  @jsonMember({name: 'bandwidth'})
  public Bandwidth!: number;

  @jsonMember({name: 'coderate'})
  public Coderate!: string;
}
